import React from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
// import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";

const Error404 = () => {
  // const navigate = useNavigate();
  const route = all_routes;

  // const handleGoBack = () => {
  //   navigate(-1);
  // };
  
  return (
    <div className="main-wrapper">
      <div className="error-box">
        <div className="error-img">
          <ImageWithBasePath
            src="assets/img/authentication/error-404.png"
            className="img-fluid"
            alt
          />
        </div>
        <h3 className="h2 mb-3">Oups, quelque chose s&apos;est mal passé</h3>
        <p>
          Erreur 404 Page introuvable. Désolé, la page que vous recherchez n&apos;existe pas ou a été déplacé
        </p>
        {/* <button onClick={handleGoBack} className="btn btn-primary">
          Retour
        </button> */}
        <Link to={route.signin} className="btn btn-primary">
          Retour
        </Link>
      </div>
    </div>
  );
};

export default Error404;
